var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.listContentShow == 2
    ? _c(
        "div",
        {
          staticClass: "task-list-list",
          class: _vm.showBatchDel ? "delete-show" : "delete-hide"
        },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                stripe: "",
                data: _vm.tasklistData,
                "row-key": "id",
                "tooltip-effect": "dark",
                "cell-class-name": _vm.cellClassName,
                "header-cell-class-name": _vm.cellClassName
              },
              on: {
                "row-click": _vm.clickRow,
                "selection-change": _vm.deleteHandleSelectionChange,
                "header-dragend": _vm.onHeaderDragEnd
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "20" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("language.common.taskName"),
                  "min-width": "230"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "list-name-item" },
                            [
                              _c("div", {
                                staticClass: "icon",
                                class: scope.row.icon + "-black"
                              }),
                              _vm._v(" "),
                              _vm.isFlag != scope.$index
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "table-cell table-cell-name",
                                      attrs: { title: scope.row.name },
                                      on: {
                                        click: function($event) {
                                          return _vm.editTaskListName(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isFlag == scope.$index
                                ? _c("el-input", {
                                    ref: "listInputName",
                                    staticClass: "table-card-edit",
                                    attrs: {
                                      disabled: _vm.isFlag != scope.$index,
                                      type: "textarea",
                                      autosize: { minRows: 1, maxRows: 2 },
                                      resize: "none"
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.submitTaskListName(scope.row)
                                      }
                                    },
                                    nativeOn: {
                                      keydown: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.enterEvent(scope.row, $event)
                                      }
                                    },
                                    model: {
                                      value: _vm.changeNameTemp,
                                      callback: function($$v) {
                                        _vm.changeNameTemp = $$v
                                      },
                                      expression: "changeNameTemp"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3190755556
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("language.common.from"),
                  "min-width": "280"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.fromItem
                            ? _c("div", { staticClass: "list-route-item" }, [
                                scope.row.fromItem.icons.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "task-icon-multi",
                                        staticStyle: { float: "left" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openFunctionPopup(
                                              8,
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._l(
                                          scope.row.fromItem.icons.slice(0, 4),
                                          function(fromItem, index) {
                                            return _c("div", {
                                              key: index,
                                              staticClass:
                                                "clouds_logo clouds_logo_20",
                                              class: fromItem.driveType,
                                              style:
                                                scope.row.fromItem.icons
                                                  .length == 3 && index == 0
                                                  ? "margin: 0 10px;"
                                                  : ""
                                            })
                                          }
                                        ),
                                        _vm._v(" "),
                                        scope.row.fromItem.icons.length > 4 &&
                                        scope.row.fromItem.icons.length < 10
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "task-icon-multi-more"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.fromItem.icons
                                                      .length
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.fromItem.icons.length > 9
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "task-icon-multi-more"
                                              },
                                              [_vm._v("9+")]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _c("div", {
                                      staticClass: "clouds_logo clouds_logo_40",
                                      class:
                                        scope.row.fromItem.icons[0].driveType,
                                      staticStyle: { float: "left" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toSourceCatalog(scope.row)
                                        }
                                      }
                                    }),
                                _vm._v(" "),
                                _c("div", { staticClass: "table-cell" }, [
                                  scope.row.fromItem.icons.length > 1
                                    ? _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: _vm.getCatalog(
                                              scope.row.fromItem.lists[0].nodes
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openFunctionPopup(
                                                8,
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.taskList.multiClouds"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c("span", [
                                        scope.row.fromItem.lists[0].driveType ==
                                        "offlinesTask"
                                          ? _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.copyLink(
                                                      scope.row.fromItem
                                                        .lists[0].name
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.common.copyLink"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                attrs: {
                                                  title: _vm.getCatalog(
                                                    scope.row.fromItem.lists[0]
                                                      .nodes
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toSourceCatalog(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNewCloudName(
                                                      scope.row.fromItem
                                                        .lists[0]
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                      ])
                                ])
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4023973109
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("language.common.to"),
                  "min-width": "280"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.toItem
                            ? _c("div", { staticClass: "list-route-item" }, [
                                scope.row.toItem.icons.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "task-icon-multi",
                                        staticStyle: { float: "left" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openFunctionPopup(
                                              8,
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._l(
                                          scope.row.toItem.icons.slice(0, 4),
                                          function(toItem, index) {
                                            return _c("div", {
                                              key: index,
                                              staticClass:
                                                "clouds_logo clouds_logo_20",
                                              class: toItem.driveType,
                                              style:
                                                scope.row.toItem.icons.length ==
                                                  3 && index == 0
                                                  ? "margin: 0 10px;"
                                                  : ""
                                            })
                                          }
                                        ),
                                        _vm._v(" "),
                                        scope.row.toItem.icons.length > 4 &&
                                        scope.row.toItem.icons.length < 10
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "task-icon-multi-more"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.toItem.icons
                                                      .length
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.toItem.icons.length > 9
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "task-icon-multi-more"
                                              },
                                              [_vm._v("9+")]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _c("div", {
                                      staticClass: "clouds_logo clouds_logo_40",
                                      class:
                                        scope.row.toItem.icons[0].driveType,
                                      staticStyle: { float: "left" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toAimCatalog(scope.row)
                                        }
                                      }
                                    }),
                                _vm._v(" "),
                                _c("div", { staticClass: "table-cell" }, [
                                  scope.row.toItem.icons.length > 1
                                    ? _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: _vm.getCatalog(
                                              scope.row.toItem.lists[0].nodes
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openFunctionPopup(
                                                8,
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.taskList.multiClouds"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toAimCatalog(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          scope.row.type == 6 &&
                                          (scope.row.tranferWay == "restore" ||
                                            scope.row.tranferWay ==
                                              "retry-restore") &&
                                          (scope.row.status == 1 ||
                                            scope.row.status == 2) &&
                                          !scope.row.isRestoreNew
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "language.cloudBackup.original"
                                                      )
                                                    ) +
                                                    "\n                            "
                                                )
                                              ])
                                            : _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    title: _vm.getCatalog(
                                                      scope.row.toItem.lists[0]
                                                        .nodes
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getNewCloudName(
                                                        scope.row.toItem
                                                          .lists[0]
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                ])
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3996369400
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("language.common.schedule"),
                  "min-width": "220"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.schedules
                            ? _c("div", [
                                _vm.isShowSchdule(scope.row)
                                  ? _c(
                                      "div",
                                      {},
                                      [
                                        _c("tabTaskSchdule", {
                                          ref: "tabTaskSchdule",
                                          attrs: { task: scope.row },
                                          on: {
                                            update: _vm.clickScheduleBtn,
                                            "open-popup": _vm.openFunctionPopup
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4083967306
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("language.common.status"),
                  "min-width": "220"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "list-state" },
                            [
                              _c("tabTaskStatus", {
                                ref: "tabTaskStatus",
                                attrs: {
                                  task: scope.row,
                                  progress: _vm.progress
                                },
                                on: { "open-popup": _vm.openFunctionPopup }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4015459120
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "", "min-width": "220" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "list-btns",
                              on: {
                                mouseleave: function($event) {
                                  return _vm.changeOptionMenu(false)
                                }
                              }
                            },
                            [
                              _c("tabTaskOption", {
                                ref: "tabTaskOption",
                                attrs: { task: scope.row },
                                on: {
                                  "open-popup": _vm.openFunctionPopup,
                                  update: _vm.clickButton
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  806063257
                )
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5da8b6e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da8b6e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_single_task_form.vue
// module id = null
// module chunks = 